import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { GlobalService } from '@app/shared/services/global/global.service';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleAuthGuard implements CanActivateChild {
  availableRoutes: any;
  constructor(
    private localStorageService: LocalStorageService,
    private _GlobalService: GlobalService
  ) {

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const requiredRole = next.data.role
    console.log("next value::", next,);
    console.log("state value::", state,);
    this.loadAvailableRoutes()

    return true;
  }

  private loadAvailableRoutes(): Observable<void> {
    const userRole = this.localStorageService.getLocalStorageItem("user");
    let role = JSON.parse(userRole);
    console.log("userStr::", role, role.role_id);
    let role_id = role.role_id;
    console.log("role_id::", (role_id));
    this._GlobalService.getRoleListRoutes(role_id).subscribe(
      (res) => {
        this._GlobalService.setPermission(res.data);
      }
    )
    return;
  }

}
